/* eslint-disable no-console */
import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import { MdCheck, MdUpload } from 'react-icons/md';
import { format, parseISO } from 'date-fns';
import { IoMdClose } from 'react-icons/io';
import { Form } from '@unform/web';
import { FaRegFilePdf } from 'react-icons/fa6';
import { FormHandles } from '@unform/core';
import { HiCheck } from 'react-icons/hi';
import { TableList, Container, Filter, Status, Modal } from './styles';

import api from '~/services/api';
import getValidationErros from '~/utils/getValidationsErrors';

import Table, { IColumn } from '~/components/Table';
import FiltersLists from '~/components/FiltersLists';
import { formatPrice } from '~/utils/format';
import { KrClose, KrEye } from '~/components/KoroIcons';
import Input from '~/components/Input';
import Loading from '~/components/Loading';
import InputMask from '~/components/InputMask';
import { IOption } from '~/components/Select';

interface ITicket {
  id: number;
  item_id: number;
  batchCategory_id: number;
  number: string;
  value: number;
  name: string;
  document: string;
  modality: string;
  category: string;
  isChecked: boolean;
  discount: number;
}

interface ICancellation {
  id?: number;
  event_id?: number;
  payment_id?: number;
  koro_value: string;
  order_id?: number;
  user_id?: number;
  request_id?: string;
  request_date?: string;
  order_date?: string;
  request_type?: string;
  event: string;
  buyer_name: string;
  buyer_cpf: string;
  buy_date: string;
  order_number: string;
  ticket_quantity: string;
  order_value: string;
  cancel_quantity?: string;
  cancel_value?: string;
  payment_status?: string;
  execution_date?: string;
  tax_value?: string;
  file?: string;
  file_name?: string;
  tickets: ITicket[];
}

interface IItem {
  id: number;
  ticket: {
    id: number;
    code: string;
    document: string;
    name: string;
  };
  batchCategory: {
    id: number;
    category: {
      name: string;
    };
    modality: {
      name: string;
    };
  };
  price: string;
}

interface ICancellationTicket {
  id: number;
  cancellation_id: number;
  order_item_id: number;
  ticket_id: number;
  batch_category_id: number;
  price: string;
  item: IItem;
}

interface ICancellationData {
  id: number;
  request_date: string;
  type: number;
  quantity: number;
  request: string;
  value: string;
  discount: string;
  order: string;
  organizer: string;
  status: string;
  payment_date: string;
  event: {
    code: string;
    name: string;
  };
  orderData: {
    code: string;
    total: string;
    discount: string;
    created_at: string;
    user: {
      name: string;
      additionalInformation: {
        document: string;
      };
    };
    items: {
      id: string;
    }[];
  };
  cancellationsTickets: ICancellationTicket[];
  organizerData: {
    name: string;
  };

  archive: {
    archive_url: string;
  };
}

interface ICancellationsResponse {
  data: ICancellationData[];
  from: number;
  to: number;
  total: number;
  pages: number;
}

interface IOrderResponse {
  installments: number;
  event_id: number;
  user_id: number;
  code: string;
  created_at: string;
  name: string;
  total: string;
  discount: string;
  payment: {
    id: number;
    installment: number;
  };
  user: {
    additionalInformation: {
      document: string;
    };
  };
  event: {
    name: string;
    contract: {
      monthly_tax: string;
      service_type: string;
      service: string;
      tax_type: string;
      tax: string;
    };
  };
  items: IItem[];
}

interface IOrganizer {
  id: number;
  name: string;
}

const Cancels: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [pageSelected, setPageSelected] = useState(1);
  const [data, setData] = useState<ICancellation[]>([]);
  const [tableData, setTableData] = useState({
    from: 0,
    to: 0,
    total: 0,
    totalPage: 0,
    generalTotal: 0,
  });
  const [filesData, setFilesData] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showView, setShowView] = useState(false);
  const [proof, setProof] = useState('');
  const [proofName, setProofName] = useState('');
  const [cancelattion, setCancelattion] = useState({} as ICancellation);
  const [showRequestCancel, setShowRequestCancel] = useState(false);
  const [totalValue, setTotalValue] = useState(0);
  const [organizers, setOrganizers] = useState<IOption[]>([]);
  const [buyerName, setBuyerName] = useState<string | undefined>(undefined);
  const [organizerId, setOrganizerId] = useState<string | undefined>(undefined);
  const [eventName, setEventName] = useState<string | undefined>(undefined);
  const [order, setOrder] = useState<string | undefined>(undefined);
  const [startDate, setStartDate] = useState<string | undefined>(undefined);
  const [endDate, setEndDate] = useState<string | undefined>(undefined);
  const [quantity, setQuantity] = useState(10);
  const [totalWithTax, setTotalWithTax] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalValueWithDiscount, setTotalValueWithDiscount] = useState(0);
  const [totalWithTaxAndDiscount, setTotalWithTaxAndDiscount] = useState(0);
  const [serviceTaxType, setServiceTaxType] = useState('Porcentagem');
  const [serviceTax, setServiceTax] = useState(0);
  const [processingTaxType, setProcessingTaxType] = useState('Porcentagem');
  const [processingTax, setProcessingTax] = useState(0);
  const [installment, setInstallment] = useState(0);
  const [monthlyTax, setMonthlyTax] = useState(0);
  const [isDiscount100Percent, setIsDiscount100Percent] = useState(false);

  useEffect(() => {
    api.get<IOrganizer[]>('organizers').then((response) => {
      const dataOrganizers = response.data.map<IOption>((organizer) => ({
        id: organizer.id,
        value: organizer.name,
        selected: false,
      }));
      setOrganizers(dataOrganizers);
    });
  }, []);

  useEffect(() => {
    if (Object.keys(cancelattion).length > 0 && cancelattion.tickets) {
      const subTotal = cancelattion.tickets.reduce((previous, current) => {
        return previous + (current.isChecked ? current.value : 0);
      }, 0);
      const discount = cancelattion.tickets.reduce((previous, current) => {
        return previous + (current.isChecked ? current.discount : 0);
      }, 0);

      let serviceFee = 0;
      let processingFee = 0;

      if (serviceTaxType === 'Porcentagem') {
        serviceFee = subTotal * (serviceTax / 100);
      } else {
        serviceFee = serviceTax;
      }
      if (processingTaxType === 'Porcentagem') {
        processingFee = subTotal * (processingTax / 100);
      } else {
        processingFee = processingTax;
      }

      let total = subTotal + serviceFee + processingFee;

      if (installment > 1) {
        const installmentValue =
          (total * monthlyTax) / (1 - (1 + monthlyTax) ** -installment);

        total = parseFloat((installmentValue * installment).toFixed(2));
      }

      setTotalValue(subTotal);
      setTotalWithTax(total);
      setTotalDiscount(discount);
      setTotalValueWithDiscount(subTotal > 0 ? subTotal - discount : subTotal);
      setTotalWithTaxAndDiscount(total > 0 ? total - discount : total);

      if (discount > 0 && installment > 1) {
        total = subTotal + serviceFee + processingFee - discount;
        const installmentValue =
          (total * monthlyTax) / (1 - (1 + monthlyTax) ** -installment);

        total = parseFloat((installmentValue * installment).toFixed(2));
        setTotalWithTax(total + discount);
        setTotalWithTaxAndDiscount(total);
      }
    }
  }, [
    cancelattion,
    installment,
    monthlyTax,
    processingTax,
    processingTaxType,
    serviceTax,
    serviceTaxType,
  ]);

  const handleLoadCancels = useCallback(
    async (
      page: number,
      buyer_name?: string,
      organizer_id?: string,
      event?: string,
      orderData?: string,
      dateStart?: string,
      dateEnd?: string,
      quantityData?: number
    ) => {
      setLoading(true);
      const response = await api.get<ICancellationsResponse>(`cancellations`, {
        params: {
          page,
          buyer_name,
          organizer_id,
          event,
          order: orderData,
          startDate: dateStart ? new Date(dateStart) : undefined,
          endDate: dateEnd ? new Date(dateEnd) : undefined,
          quantity: quantityData,
        },
      });

      const cancellationData = response.data.data.map<ICancellation>(
        (cancellation) => {
          const tickets = cancellation.cancellationsTickets.map<ITicket>(
            (cancellationTicket) => ({
              id: cancellationTicket.item.ticket.id,
              item_id: cancellationTicket.order_item_id,
              batchCategory_id: cancellationTicket.batch_category_id,
              number: cancellationTicket.item.ticket.code,
              value: parseFloat(cancellationTicket.price),
              name: cancellationTicket.item.ticket.name || '-',
              document: cancellationTicket.item.ticket.document || '-',
              modality: cancellationTicket.item.batchCategory.modality.name,
              category: cancellationTicket.item.batchCategory.category.name,
              isChecked: true,
              discount: cancellation.discount
                ? parseFloat(cancellation.discount) /
                  cancellation.cancellationsTickets.length
                : 0,
            })
          );

          return {
            id: cancellation.id,
            request_id: cancellation.id.toString(),
            request_date: format(
              parseISO(cancellation.request_date),
              'dd/MM/yyyy'
            ),
            request_type: cancellation.type === 1 ? 'Total' : 'Parcial',
            event: cancellation.event.name,
            buyer_name: cancellation.orderData.user.name,
            buyer_cpf:
              cancellation.orderData.user.additionalInformation.document,
            buy_date: format(
              parseISO(cancellation.orderData.created_at),
              'dd/MM/yyyy'
            ),
            koro_value: formatPrice(
              parseFloat(cancellation.value) - parseFloat(cancellation.order)
            ),
            order_number: cancellation.orderData.code,
            ticket_quantity: cancellation.orderData.items.length.toString(),
            order_value: formatPrice(parseFloat(cancellation.order)),
            cancel_quantity: cancellation.quantity.toString(),
            cancel_value: formatPrice(parseFloat(cancellation.value)),
            payment_status: cancellation.status,
            execution_date: cancellation.payment_date
              ? format(parseISO(cancellation.payment_date), 'dd/MM/yyyy')
              : '-',
            tax_value:
              parseFloat(cancellation.organizer) > 0
                ? formatPrice(parseFloat(cancellation.organizer))
                : '-',
            organizer: cancellation.organizerData.name,
            tickets,
            file: cancellation.archive?.archive_url,
          };
        }
      );

      console.log(cancellationData);

      setData(cancellationData);

      setTableData((oldState) => ({
        from: response.data.from,
        to: response.data.to,
        total: response.data.total,
        totalPage: response.data.pages,
        generalTotal: oldState.generalTotal
          ? oldState.generalTotal
          : response.data.total,
      }));
      setLoading(false);
    },
    []
  );

  useEffect(() => {
    handleLoadCancels(1);
  }, [handleLoadCancels]);

  const handleClickCheck = useCallback((row: ICancellation) => {
    setCancelattion(row);
    setShow(true);
  }, []);

  const handleClickView = useCallback((row) => {
    setShowView(true);
    setProof(row.file);
    setProofName(row.file_name ?? '');
  }, []);

  const handleClickViewRequest = useCallback(async (row: ICancellation) => {
    const orderId = parseInt(row.order_number.slice(12), 10);
    const response = await api.get<IOrderResponse>(`orders/${orderId}`);

    setMonthlyTax(parseFloat(response.data.event.contract.monthly_tax));
    setServiceTaxType(response.data.event.contract.service_type);
    setServiceTax(parseFloat(response.data.event.contract.service));
    setProcessingTaxType(response.data.event.contract.tax_type);
    setProcessingTax(parseFloat(response.data.event.contract.tax));
    setInstallment(response.data.installments);
    setIsDiscount100Percent(response.data.discount === response.data.total);

    const tickets = response.data.items.map<ITicket>((item) => ({
      id: item.ticket.id,
      item_id: item.id,
      batchCategory_id: item.batchCategory.id,
      number: item.ticket.code,
      name: item.ticket.name || '-',
      document: item.ticket.document || '-',
      category: item.batchCategory.category.name,
      modality: item.batchCategory.modality.name,
      value: parseFloat(item.price),
      discount: response.data.discount
        ? parseFloat(response.data.discount) / response.data.items.length
        : 0,
      isChecked:
        row.request_type === 'Total' ||
        row.tickets.some((ticket) => ticket.id === item.ticket.id),
    }));

    setCancelattion({
      ...row,
      order_date: row.buy_date,
      tickets,
    });
    setShowRequestCancel(true);
  }, []);

  const handleSubmit = useCallback(
    async (formData) => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          cancel_value: Yup.string().required(
            'O valor do cancelamento é obrigatório'
          ),
          refund_value: Yup.string().required(
            'O valor do reembolso Koro é obrigatório'
          ),
          receipt: Yup.string().when(`$checkReceipt`, {
            is: (checkReceipt: boolean) => checkReceipt,
            then: Yup.string().required('O comprovante é obrigatório'),
            otherwise: Yup.string(),
          }),
        });

        await schema.validate(formData, {
          abortEarly: false,
          context: {
            checkReceipt: filesData.length === 0,
          },
        });

        const fileFormData = new FormData();
        fileFormData.append('file', filesData[0]);
        fileFormData.append('folder', 'receipts');

        const responseFile = await api.post('archives/admin', fileFormData);

        await api.patch(`cancellations/confirm/${cancelattion.id}`, {
          archive_id: responseFile.data.id,
          value: parseFloat(
            formData.cancel_value
              .replace('R$', '')
              .replaceAll('.', '')
              .replace(',', '.')
          ),
          koro_value: parseFloat(
            formData.refund_value
              .replace('R$', '')
              .replaceAll('.', '')
              .replace(',', '.')
          ),
          status: 'Cancelamento realizado',
        });

        const cancelattionIndex = data.findIndex(
          (cancelattionData) => cancelattionData.id === cancelattion.id
        );

        if (cancelattionIndex >= 0) {
          data[cancelattionIndex].execution_date = format(
            new Date(),
            'dd/MM/yyyy'
          );
          data[cancelattionIndex].payment_status = 'Cancelamento realizado';
          data[cancelattionIndex].file = URL.createObjectURL(filesData[0]);
          data[cancelattionIndex].file_name = filesData[0].name;
        }

        setData(data);
        setShow(false);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Ocorreu um erro tente novamente!');
        }
      } finally {
        setLoading(false);
      }
    },
    [cancelattion.id, data, filesData]
  );

  const columns = useMemo<IColumn[]>(
    () => [
      {
        name: 'ID Solicitação',
        selector: 'request_id',
        sortable: true,
      },

      {
        name: 'Dt Solicitação',
        selector: 'request_date',
        sortable: true,
      },
      {
        name: 'Tipo Solicitação',
        selector: 'request_type',
        sortable: true,
      },
      {
        name: 'Evento',
        selector: 'event',
        sortable: true,
      },

      {
        name: 'Status',
        selector: 'payment_status',
        sortable: true,
        cell: (row) => (
          <Status
            status={row.payment_status}
            className="text-white rounded-pill mb-0"
          >
            {row.payment_status}
          </Status>
        ),
      },
      {
        name: 'Nome Comprador',
        selector: 'buyer_name',
        sortable: true,
      },
      {
        name: 'Dt Compra',
        selector: 'buy_date',
        sortable: true,
      },
      {
        name: 'Nro Pedido',
        selector: 'order_number',
        sortable: true,
      },
      {
        name: 'Qtd Inscrições',
        selector: 'ticket_quantity',
        sortable: true,
      },
      {
        name: 'Valor Pedido',
        selector: 'order_value',
        sortable: true,
      },
      {
        name: 'Qtd Cancelada',
        selector: 'cancel_quantity',
        sortable: true,
      },
      {
        name: 'Valor Cancelado',
        selector: 'cancel_value',
        sortable: true,
      },

      {
        name: 'Dt execução',
        selector: 'execution_date',
        sortable: true,
      },
      {
        name: 'Valor Taxas',
        selector: 'tax_value',
        sortable: true,
      },

      {
        name: 'Organizador',
        selector: 'organizer',
        sortable: true,
      },

      {
        name: '',
        selector: 'active',
        sortable: false,
        cell: (row) => (
          <>
            <button
              type="button"
              onClick={() => handleClickViewRequest(row)}
              className={` btn-icons border-0 me-2`}
            >
              <KrEye size={16} color="#fff" />
            </button>
            <button
              type="button"
              onClick={() => handleClickView(row)}
              className={`${
                !row.file ? 'pe-none opacity-50' : ''
              } btn-icons border-0 me-2`}
              disabled={!row.file}
            >
              <KrEye size={16} color="#fff" />
            </button>
            <button
              type="button"
              onClick={() => handleClickCheck(row)}
              className={`${
                row.payment_status === 'Pago' ||
                row.payment_status === 'Cancelamento realizado'
                  ? 'pe-none opacity-50'
                  : ''
              } btn-icons border-0`}
            >
              <MdCheck size={16} color="#fff" />
            </button>
          </>
        ),
      },
    ],
    [handleClickCheck, handleClickView, handleClickViewRequest]
  );

  const handleClose = useCallback(() => {
    setShow(false);
    setShowView(false);
    setShowRequestCancel(false);
    setFilesData([]);
  }, []);

  const handleDeleteColor = useCallback((indexToDelete) => {
    setFilesData((prevFiles) =>
      prevFiles.filter((file, index) => index !== indexToDelete)
    );
  }, []);

  const handleDrop = useCallback((event: React.DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
    const { files } = event.dataTransfer;
    if (files) {
      setFilesData(Array.from(files));
    }
  }, []);

  const handleDragOver = useCallback(
    (event: React.DragEvent<HTMLLabelElement>) => {
      event.preventDefault();
    },
    []
  );

  const handleFileChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { files } = event.target;
      if (files) {
        setFilesData(Array.from(files));
        const inputElement = document.getElementById(
          `photos`
        ) as HTMLInputElement;

        if (inputElement) {
          inputElement.value = '';
        }
      }
    },
    []
  );

  const handleChangePage = useCallback(
    (page) => {
      if (page <= tableData.totalPage) {
        handleLoadCancels(
          page,
          buyerName,
          organizerId,
          eventName,
          order,
          startDate,
          endDate,
          quantity
        );
        setPageSelected(page);
      }
    },
    [
      buyerName,
      endDate,
      eventName,
      handleLoadCancels,
      order,
      organizerId,
      quantity,
      startDate,
      tableData.totalPage,
    ]
  );

  const handleSubmitFilters = useCallback(
    (formData) => {
      setBuyerName(formData.name || undefined);
      setOrganizerId(
        formData.organizer !== 'todos' ? formData.organizer : undefined
      );
      setEventName(formData.event === 'Todos' ? undefined : formData.event);
      setOrder(formData.order || undefined);
      setStartDate(formData.dateStart);
      setEndDate(formData.dateEnd);
      handleLoadCancels(
        1,
        formData.name || undefined,
        formData.organizer !== 'todos' ? formData.organizer : undefined,
        formData.event === 'Todos' ? undefined : formData.event,
        formData.order || undefined,
        formData.dateStart,
        formData.dateEnd,
        quantity
      );
      setPageSelected(1);
    },
    [handleLoadCancels, quantity]
  );

  const handleChangeQuantity = useCallback(
    (quantityData) => {
      handleLoadCancels(
        1,
        buyerName,
        organizerId,
        eventName,
        order,
        startDate,
        endDate,
        quantityData
      );
      setQuantity(quantityData);
      setPageSelected(1);
    },
    [
      buyerName,
      endDate,
      eventName,
      handleLoadCancels,
      order,
      organizerId,
      startDate,
    ]
  );

  return (
    <Container>
      <div className="container-fluid">
        <div className="row">
          <div className="zoom col-12 px-0">
            <div className="bg-white d-sm-flex justify-content-between align-items-center p-4">
              <h1 className="mb-0">Cancelamentos</h1>
              {/* <ExportCsv
                data={data}
                columns={columns}
                fileName="Solicitacoes de saque"
              /> */}
            </div>
          </div>
          <Filter className="col-12 px-0 mt-3">
            <FiltersLists
              onSubmitFilters={handleSubmitFilters}
              organizer
              event
              order
              name
              nameUser
              date
              organizersData={organizers}
            />
          </Filter>
          <div className="col-12 px-0">
            <div className="row">
              <TableList className="col-12 mt-3">
                <div className="bg-white pb-2">
                  <div className="bg-white overflow-auto">
                    <div className="">
                      <Table
                        className="mb-0 p-0 table"
                        columns={columns}
                        data={data}
                        pagination
                        changeQuantity
                        showTotals
                        generalTotal={tableData.generalTotal}
                        totalData={tableData.total}
                        selectedPage={pageSelected}
                        onChangePage={handleChangePage}
                        onChangeQuantity={handleChangeQuantity}
                      />
                    </div>
                  </div>
                </div>
              </TableList>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={show}
        onHide={handleClose}
      >
        <Form onSubmit={handleSubmit}>
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
            <Modal.Title className="mb-0 mt-4">
              <h2 className="title mb-0">Pedido de Cancelamento</h2>
            </Modal.Title>
            <button
              type="button"
              onClick={handleClose}
              className="border-0 bg-transparent"
            >
              <KrClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="pt-0 px-3 px-sm-5">
            <div className="row">
              <div className="col-12">
                <hr />
                <h3 className="my-5">Dados do Pagamento</h3>
              </div>
              <div className="col-6">
                <label className="d-block mt-3">
                  <span className="h6 d-block fw-normal">
                    Valor do Cancelamento
                  </span>
                  <InputMask
                    className="input mt-2"
                    kind="money"
                    placeholder="R$"
                    name="cancel_value"
                    value={cancelattion.cancel_value}
                  />
                </label>
              </div>
              <div className="col-6">
                <label className="d-block mt-3">
                  <span className="h6 d-block fw-normal">
                    Valor do Reembolso Koro
                  </span>
                  <InputMask
                    className="input mt-2"
                    kind="money"
                    placeholder="R$"
                    name="refund_value"
                    value={cancelattion.koro_value}
                  />
                </label>
              </div>

              <>
                <div className="col-12">
                  <label
                    htmlFor="receipt"
                    className="w-100 label-modal text-center mt-3"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                  >
                    <MdUpload size={48} color="#FF6900" />
                    <span className="d-block">
                      Arraste e solte o arquivo aqui para
                      <br />
                      adicionar um comprovante
                    </span>
                    <span className="d-inline-flex my-2">
                      Selecionar arquivo
                    </span>
                    <span className="d-block">
                      Extensões aceitas: pdf, jpg, png, jpeg.
                    </span>
                  </label>
                  <Input
                    id="receipt"
                    type="file"
                    name="receipt"
                    className="d-none"
                    onChange={(e) => handleFileChange(e)}
                  />
                  {filesData.map((file, index) => (
                    <div
                      // eslint-disable-next-line react/no-array-index-key
                      key={index}
                      className="d-flex justify-content-between arquives p-3 mt-3"
                    >
                      <div className="d-flex align-items-center">
                        {file.name.toLowerCase().includes('.pdf') ? (
                          <FaRegFilePdf size={30} color="#8c8c8c" />
                        ) : (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                          />
                        )}

                        <p className="ms-3 mb-0">{file.name}</p>
                      </div>
                      <button
                        type="button"
                        className="bg-transparent border-0"
                        onClick={() => handleDeleteColor(index)}
                      >
                        <IoMdClose size={24} color="#8C8C8C" />
                      </button>
                    </div>
                  ))}
                </div>
              </>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4 px-5">
            <button
              type="submit"
              disabled={filesData.length === 0}
              className="me-auto btn-filter d-flex align-items-center justify-content-center btn h6 fw-normal py-2 px-4 mt-2 mb-0"
            >
              Confirmar cancelamento
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={showView}
        onHide={handleClose}
      >
        <Modal.Header className="position-relative justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
          {/* <button
            type="button"
            onClick={handleDeleteProof}
            className="border-0 bg-transparent"
          >
            <KrTrash size={20} color="#f00" />
          </button> */}
          <Modal.Title className="mb-0 mt-4">
            <h2 className="title mb-0">Comprovante</h2>
          </Modal.Title>
          <button
            type="button"
            onClick={handleClose}
            className="border-0 bg-transparent"
          >
            <KrClose size={20} color="#989898" />
          </button>
        </Modal.Header>
        <Modal.Body className="pt-0 px-3 px-sm-5">
          <div className="row">
            <div className="col-12">
              <hr />
            </div>
            <div className="col-12">
              {proofName.toLowerCase().includes('.pdf') ||
              proof.toLowerCase().includes('.pdf') ? (
                <iframe
                  className="w-100"
                  height={500}
                  title="Comprovante"
                  src={proof}
                  frameBorder="0"
                />
              ) : (
                <img className="w-100 mb-5" src={proof} alt={proof} />
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={showRequestCancel}
        onHide={handleClose}
      >
        <Form onSubmit={handleSubmit}>
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
            <Modal.Title className="mb-0 mt-4">
              <h2 className="title mb-0">Solicitação cancelamento</h2>
            </Modal.Title>
            <button
              type="button"
              onClick={handleClose}
              className="border-0 bg-transparent"
            >
              <KrClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="pt-0 px-3 px-sm-5">
            <div className="row">
              <div className="col-12">
                <hr />
              </div>
              <div className="col-6">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">Número do pedido</span>
                  <Input
                    name="order_number"
                    type="number"
                    className="input"
                    value={cancelattion.order_number}
                  />
                </label>
              </div>
              <div className="col-6">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">Data do pedido</span>
                  <Input
                    name="order_number"
                    className="input"
                    value={cancelattion.order_date}
                  />
                </label>
              </div>
              <div className="col-6">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">Comprador</span>
                  <Input
                    name="buyer_name"
                    className="input"
                    value={cancelattion.buyer_name}
                  />
                </label>
              </div>
              <div className="col-6">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">CPF</span>
                  <InputMask
                    className="input mt-2"
                    kind="cpf"
                    name="buyer_cpf"
                    value={cancelattion.buyer_cpf}
                  />
                </label>
              </div>
              <div className="col-12">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">Evento</span>
                  <Input
                    name="event"
                    className="input"
                    value={cancelattion.event}
                  />
                </label>
              </div>
              <div className="col-6">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">
                    Tipo de Cancelamento
                  </span>
                  <div className="d-flex mt-3">
                    <button
                      type="button"
                      className="d-flex align-items-center check border-0 bg-transparent me-4"
                    >
                      <span
                        className={`${
                          cancelattion.request_type === 'Total' ? 'checked' : ''
                        } me-2`}
                      >
                        {cancelattion.request_type === 'Total' && (
                          <HiCheck
                            size={16}
                            color="#fff"
                            className="check-icon"
                          />
                        )}
                      </span>
                      Total
                    </button>
                    <button
                      type="button"
                      className="d-flex align-items-center check border-0 bg-transparent"
                    >
                      <span
                        className={`${
                          cancelattion.request_type === 'Parcial'
                            ? 'checked'
                            : ''
                        } me-2`}
                      >
                        {cancelattion.request_type === 'Parcial' && (
                          <HiCheck
                            size={16}
                            color="#fff"
                            className="check-icon"
                          />
                        )}
                      </span>
                      Parcial
                    </button>
                  </div>
                </label>
              </div>
              <div className="col-6">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">
                    Valor do Cancelamento
                  </span>
                  <InputMask
                    className="input mt-2"
                    kind="money"
                    placeholder="R$"
                    name="cancel_value"
                    value={cancelattion.cancel_value}
                  />
                </label>
              </div>
              <div className="col-12 pe-none mt-3">
                <span className="h6 d-block fw-normal">Inscrições</span>
                <div className="t-container">
                  <div className="t-header d-flex p-2">
                    <span>Número</span>
                    <span>Modalidade - Categoria</span>
                    <span>Nome</span>
                    <span>CPF</span>
                    <span>Valor unitário</span>
                  </div>
                  <div className="t-body py-3">
                    {cancelattion.tickets?.map((ticket) => (
                      <div className="d-flex align-items-center py-1">
                        <span className="d-flex justify-content-center align-items-center px-2">
                          <button
                            type="button"
                            className="d-flex align-items-center check border-0 bg-transparent"
                          >
                            <span
                              className={`${
                                ticket.isChecked ? 'checked' : ''
                              } check-list me-2 d-flex justify-content-center align-items-center`}
                            >
                              <HiCheck
                                size={13}
                                color="#fff"
                                className="check-icon"
                              />
                            </span>
                          </button>
                          {ticket.number}
                        </span>

                        <span className="px-2">
                          {ticket.modality} - {ticket.category}
                        </span>
                        <span className="px-2">{ticket.name}</span>
                        <span className="px-2">{ticket.document}</span>
                        <span className="px-2">
                          {formatPrice(ticket.value)}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className="t-footer py-2 px-4">
                    <div className="d-flex justify-content-between">
                      <span>Total</span>
                      <span className="total">{formatPrice(totalValue)}</span>
                    </div>
                    <hr className="my-2" />
                    <div className="d-flex justify-content-between">
                      <span>Total com as taxas</span>
                      <span className="total">{formatPrice(totalWithTax)}</span>
                    </div>
                    {totalDiscount > 0 && (
                      <>
                        <hr className="my-2" />
                        <div className="d-flex justify-content-between">
                          <span>Valor de desconto</span>
                          <span className="total">
                            {isDiscount100Percent
                              ? formatPrice(totalWithTax)
                              : formatPrice(totalDiscount)}
                          </span>
                        </div>

                        <hr className="my-2" />
                        <div className="d-flex justify-content-between">
                          <span>Total com as taxas e desconto</span>
                          <span className="total">
                            {isDiscount100Percent
                              ? formatPrice(0)
                              : formatPrice(totalWithTaxAndDiscount)}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4 px-5">
            <button
              type="submit"
              onClick={handleClose}
              className="ms-auto btn-filter d-flex align-items-center justify-content-center btn h6 fw-normal py-2 px-4 mt-2 mb-0"
            >
              Fechar
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Loading active={loading} text="Carregando..." />
    </Container>
  );
};

export default Cancels;
